export default __webpack_public_path__ + "static/media/1796.fde44bcc.jpg";